import { RootState } from '../store';

export const selectToken = (state: RootState) => state.auth.token;
export const selectUser = (state: RootState) => state.auth.user;
export const selectIsAuthenticated = (state: RootState) => state.auth.isAuthenticated;
export const selectIsLoading = (state: RootState) => state.auth.isLoading;
export const selectIsUpdating = (state: RootState) => state.auth.isUpdating;
export const selectEmailVerification = (state: RootState) => state.emailVerification;
export const selectUserProfile = (state: RootState) => state.auth.userProfile;
export const selectErrors = (state: RootState) => state.auth.errors;
export const selectFirstConnectedSocial = (state: RootState) => state.auth.firstConnectedSocial;
export const selectUserSubscription = (state: RootState) => state.subscription.userSubscription;
export const selectSocialPages = (state: RootState) => state.auth.socialPages;
